import type { Transaction } from "../shared/types";
import { useQuery } from "@tanstack/react-query";
import { memberApi } from "../shared/api";
import { money } from "../shared/ui";
import { Icon } from "./MemberMobileUi";

export function TransactionSettlementSummary({ transaction, stage = "payment" }: { readonly transaction: Transaction; readonly stage?: "payment" | "transfer" }) {
  const banks = useQuery({ queryKey: ["member", "banks"], queryFn: memberApi.banks, enabled: stage === "transfer" });
  const bankName = banks.data?.find(bank => bank.code === transaction.recipientBankCode)?.name;
  return <section className="settlement-summary" data-stage={stage} aria-label={stage === "transfer" ? "송금 정보" : "결제 거래 요약"}>
    <div className="settlement-summary-heading"><span className="mr-transaction-row__icon"><Icon name="receipt" /></span>
      <div><h2 title={transaction.title}>{transaction.title}</h2><p title={transaction.recipientHolderMasked ?? undefined}>받는 분 · {transaction.recipientHolderMasked ?? "거래 상세에서 확인"}</p></div>
    </div>
    <dl>{stage === "transfer" && <div><dt>받는 분</dt><dd>{bankName ?? (banks.isPending ? "은행 확인 중" : "은행 정보 확인 필요")} {transaction.recipientAccountNumberMasked} ({transaction.recipientHolderMasked ?? "예금주 확인 필요"})</dd></div>}<div><dt>{stage === "transfer" ? "이체금액" : "결제 금액"}</dt><dd>{money(transaction.approvedAmount ?? transaction.requestedAmount)}</dd></div></dl>
  </section>;
}
